import { useEffect, useState } from "react";
import classNames from "classnames";

import Dialog from "features/components/Dialog/index";

import { DialogWithTriggerProps } from "./types";

const DialogWithTrigger = ({
  isOpened = false,
  triggerElement,
  triggerElementClassNames,
  onOpen,
  maxWidth = "md",
  ...dialogProps
}: DialogWithTriggerProps) => {
  const [modalOpen, setModalOpen] = useState(isOpened);

  useEffect(() => {
    setModalOpen(isOpened);
  }, [isOpened]);

  const onModalOpen = () => {
    setModalOpen(true);
    onOpen && onOpen();
  };

  return (
    <>
      <span
        className={classNames(
          "relative cursor-pointer",
          triggerElementClassNames
        )}
        onClick={onModalOpen}
      >
        {triggerElement}
      </span>
      <Dialog
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        fullWidth
        maxWidth={maxWidth}
        {...dialogProps}
      ></Dialog>
    </>
  );
};

export default DialogWithTrigger;
